function manageGuestStatusDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/manage-guest-status/manage-guest-status-dialog.html?$$REVISION$$'
  }
}

export { manageGuestStatusDialog }
